const rectButtonHeight = 28;

// TODO @@
// const getInputStyles = () => ({
//   background: 'linear-gradient(#FFFFFF, #E3D28C)',
//   '-webkit-background-clip': 'text',
//   '-webkit-text-fill-color': 'transparent',
//   color: 'transparent',
// });
const getInputStyles = () => ({
  background: '#383C47',
  // '-webkit-background-clip': 'text',
  // '-webkit-text-fill-color': 'transparent',
  color: 'white',
});

const styles = theme => ({
  buyInModal: {
    '& .ant-modal-body': {
      borderRadius: '10px',
      filter: 'drop-shadow(0px 2px 20px rgba(255, 255, 255, 0.5))',
    },
    '& .ant-modal-content': {
      borderRadius: '10px',
    },
    '& .ant-modal-close': {
      top: '-20px',
      right: '-20px',
      width: 'auto',
      height: 'auto',
    },
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    height: '50px',
    background: 'url("/images-mobile/NewCustomizedModal/header.svg")',
    borderRadius: '10px 10px 0px 0px',
  },
  buyInImage: {
    width: 120,
    height: 120,
    // position: 'absolute',
    // left: '50%',
    // transform: 'translate(-50%, 0)',
    // top: '-17%',
    zIndex: 1,
  },
  container: {
    padding: '0 15px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
  },
  modalContent: {
    width: '100%',
    // background: 'red',
    // position: 'absolute',
    // top: '25%',
  },

  ribbonLabel: {
    width: '120px',
    height: 46,
    background: 'url("/images-mobile/game-list/ribbon.webp") 0px 0px/ 100%',
    color: 'white',
    fontSize: 18,
    fontWeight: 400,
    lineHeight: '55px',
    paddingLeft: '10px',
  },
  modalTitle: {
    color: 'white',
    fontWeight: 600,
    fontSize: 16,
    margin: '10px 0',
  },
  buyInLabel: {
    color: theme.secondaryTextColor,
    margin: '5px 0',
  },
  buyInText: {
    marginBottom: 20,
    fontSize: 14,
    fontWeight: 600,
    color: 'white',
    textAlign: 'center',
  },
  addOrMinusRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  yellowDollar: {
    fontSize: '30px',
    paddingTop: 3,
  },
  inputArea: {
    padding: '0 15px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    // height: '40px',
    justifyContent: 'space-between',
    height: 50,
    fontWeight: 400,
    fontSize: 18,
    // '&.ant-input-number-affix-wrapper:hover': {
    //   border: 'none',
    // },
    // ...getInputStyles(),
    // '& input': {
    //   fontWeight: 400,
    //   textAlign: 'right',
    // },
    background: theme.inputBackground,
    borderRadius: '10px',
  },
  inputLabel: {
    // width: '50%',
    // textAlign: 'left',
    // marginLeft: '22px',
    // ...getInputStyles(),
    color: 'white',
    fontSize: 14,
    fontWeight: 400,
    opacity: 0.5,
  },
  antInputNumber: {
    textAlign: 'right',
    // width: '50%',
    fontWeight: 500,
    fontSize: 18,
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    '&.ant-input-number-affix-wrapper:hover': {
      border: 'none',
    },
    ...getInputStyles(),
    '& input': {
      textAlign: 'right',

      // For Firefox to work
      ...getInputStyles(),
    },
    '& >.ant-input-number-handler-wrap': {
      // background: 'black',
      '& .ant-input-number-handler:hover': {
        '&:hover, &:active, &:focus': {
          background: 'black',
          '& .ant-input-number-handler-up-inner,.ant-input-number-handler-down-inner': {
            color: 'white',
          },
        },
      },
    },
    '& >.ant-input-number-input-wrap': {
      // marginRight: '22px',
      '& input': {
        // padding: '0 1px 0 11px',
      },
    },
  },
  sliderRow: {
    // margin: [20, 20, 0, 20],
    display: 'flex',
    justifyContent: ' space-evenly',
  },
  sliderContainer: {
    display: 'flex',
    // width: '80%',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  addOrMinusBotton: {
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    fontSize: 9,
    background: 'rgba(65, 28, 64, 0.25)',
    boxShadow: ' inset 0px 1px 4px 1px rgb(255 255 255 / 40%)',
    marginBottom: 7,
    border: 'transparent',
    '&.ant-btn': {
      '&:hover, &:focus, &:active, &[disabled]': {
        background: 'rgba(65, 28, 64, 0.25)',
        boxShadow: ' inset 0px 1px 4px 1px rgb(255 255 255 / 40%)',
        border: 'transparent',
        color: 'white',
      },
    },
  },
  minMaxSpanRow: {
    color: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 15px',
    // margin: '0 20px',
  },
  formContainer: {
    color: 'white',
    '& .ant-form-item': {
      marginBottom: 0,
    },
  },
  formItemSlider: {
    width: '100%',
  },
  labelRow: {
    width: '100%',
    padding: '0 15px',
  },
  labelColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  yellowSlider: {
    // width: 208,
    display: 'flex',
    alignItems: 'center',
    width: '85%',
    margin: 'auto',
    height: 27,
    '&.ant-slider': {
      '&:hover .ant-slider-rail': {
        backgroundColor: 'transparent',
      },
    },
    '&.ant-slider:hover .ant-slider-track': {
      backgroundColor: '#FFCD3E',
    },
    '& .ant-slider-rail': {
      borderRadius: '60px',
      background: '#202633',
      boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.25) inset',

      height: '10px',
    },
    '& .ant-slider-track': {
      background: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%) !important',
      height: 10,
      borderRadius: 25,
    },
    '& .ant-slider-step': {
      display: 'none',
    },
    '& .ant-slider-handle': {
      top: 4,
      background:
        // eslint-disable-next-line max-len
        ' linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(153, 153, 153, 0.05) 100%), linear-gradient(0deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), #202633',
      border: 'none',
      height: 30,
      width: 30,
      // top: '50%',
      // transform: 'translateY(-50%)',
      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10) inset',
      '& .ant-tooltip-open': {
        border: 'none',
      },
    },
  },
  sameMinMaxTriggered: {
    '& .ant-slider-handle': {
      left: '100% !important',
    },
    '& .ant-slider-track': {
      width: '100% !important',
    },
  },
  remainingArea: {
    color: '#929292',
    fontSize: 12,
    margin: '10px 0',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  remainingSpan: {
    display: 'block',
  },
  remainingSpanLowBalance: {
    color: '#D5D5D5',
  },
  sliderMarksArea: {
    width: '80%',
    margin: 'auto',
  },
  minMaxBuyInDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: 'white',
    fontWeight: 800,
    fontSize: 12,
  },
  buyInButtonArea: {
    width: '100%',
    height: 75,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 'auto',
    borderTop: '1px solid #383D46',
  },
  buyInButton: {
    margin: '0 5px 0 5px',
    border: 'none',
    width: 205,
    height: 35,
    padding: '1px',
    borderRadius: '3px',
    background: 'linear-gradient(352.35deg, #F3B331 0%, #FBF18E 30%, #FBF18E 60%, #C6801B 90%)',
    '&.ant-btn': {
      '&:hover, &:focus, &:active, &[disabled]': {
        background:
          // eslint-disable-next-line max-len
          'linear-gradient(352.35deg, #F3B331 0%, #FBF18E 30%, #FBF18E 60%, #C6801B 90%)',
        border: 'none',
        opacity: 0.5,
      },
    },
  },
  content: {
    height: '100%',
    width: '100%',
    background:
      // eslint-disable-next-line max-len
      "url('/images-mobile/home/GoldenButton/check-background.svg'), url('/images-mobile/home/GoldenButton/dot-background.svg'), linear-gradient(170.55deg, #F0D260 7%, #A06F15 35.62%, #D4A73D 64.25%, #A17203 92.87%);",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 3,
    border: 'none',
    '&.ant-btn': {
      '&:hover, &:focus, &:active, &[disabled]': {
        background:
          // eslint-disable-next-line max-len
          "url('/images-mobile/home/GoldenButton/check-background.svg'), url('/images-mobile/home/GoldenButton/dot-background.svg'), linear-gradient(170.55deg, #F0D260 7%, #A06F15 35.62%, #D4A73D 64.25%, #A17203 92.87%);",
        border: 'none',
      },
    },
  },
  label: {
    display: 'inline-block',
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'PingFang HK',
    position: 'relative',
    '&:before': {
      content: 'attr(data-text)',
      background: 'linear-gradient(to bottom,#261603 0%, #6E4D21 100%)',
      '-webkit-text-stroke': '2px transparent',
      '-webkit-background-clip': 'text',
    },
    '&:after': {
      content: 'attr(data-text)',
      left: 0,
      top: 0,
      position: 'absolute',
      backgroundImage: 'linear-gradient(180deg, #FFFFFF 0%, #E3D28C 100%);',
      ' -webkit-background-clip': 'text',
      color: 'transparent',
    },
  },
  buyInCountdown: {
    color: '#faf7ea',
    fontSize: '15px',
    marginLeft: 10,
    // textShadow: '0px 0px 2px #241503, 0 0 2px #241503, 0 0 2px #241503',
    '& > .ant-statistic': {
      display: 'inline',
    },
  },
  hidden: {
    display: 'none',
  },
});

export default styles;
